import React from 'react';
import PropTypes from 'prop-types';
import {
  Desktop,
  Tablet,
  Mobile,
} from 'Responsive';
import LinkWithHashChange from 'LinkWithHashChange';
import WithHover from 'WithHover';

const buttonStyle = {
  padding: 0,
  background: 'none',
  border: 'none',
  outline: 'none',
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  marginBottom: 10,
};

const imageStyle = {
  height: 42,
  marginRight: 11,
};


export class SidebarGuideInfoSectionTitle extends React.Component {
  constructor(props) {
    super(props);

    this.renderButton = this.renderButton.bind(this);
    this.renderTitleContent = this.renderTitleContent.bind(this);
  }

  renderTitleContent() {
    const {
      section,
    } = this.props;

    const imgSrc = this.props.isHover ? section.iconSrcHover : section.iconSrc;
    return (
      <React.Fragment>
        <img alt="Click to open" src={imgSrc} style={imageStyle} />
        <h3>{section.title}</h3>
      </React.Fragment>
    );
  }

  renderButton() {
    const {
      enableSectionOpen,
      onClick,
      onMouseOut,
      onMouseOver,
      section,
    } = this.props;

    if (enableSectionOpen) {
      return (
        <button
          className="rank-brain-2-sidebar-guide-section-title-button"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          style={buttonStyle}
          onClick={onClick}
        >
          {this.renderTitleContent()}
        </button>
      );
    }

    const commonLinkProps = {
      style: buttonStyle,
      className: 'rank-brain-2-sidebar-guide-section-title-link btn',
      onMouseOver,
      onMouseOut,
      isDynamic: true,
      to: section.idTarget,
      spy: true,
      offset: -100,
      duration: 500,
    };

    return (
      <React.Fragment>
        <Desktop>
          <LinkWithHashChange
            smooth
            {...commonLinkProps}
          >
            {this.renderTitleContent()}
          </LinkWithHashChange>
        </Desktop>
        <Tablet>
          <LinkWithHashChange
            smooth
            {...commonLinkProps}
            onClick={this.props.toggleSideBar}
          >
            {this.renderTitleContent()}
          </LinkWithHashChange>
        </Tablet>
        <Mobile>
          <LinkWithHashChange
            {...commonLinkProps}
            onClick={this.props.toggleSideBar}
          >
            {this.renderTitleContent()}
          </LinkWithHashChange>
        </Mobile>
      </React.Fragment>
    );
  }


  render() {
    return this.renderButton();
  }
}

SidebarGuideInfoSectionTitle.defaultProps = {
  section: {},
  enableSectionOpen: false,
  isHover: false,
  onClick: () => {},
  toggleSideBar: () => {},
};

SidebarGuideInfoSectionTitle.propTypes = {
  enableSectionOpen: PropTypes.bool,
  isHover: PropTypes.bool,
  section: PropTypes.shape({
    title: PropTypes.string,
    iconSrc: PropTypes.string,
    iconSrcHover: PropTypes.string,
  }),
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  toggleSideBar: PropTypes.func,
};

const SidebarGuideInfoSectionTitleWithHover = WithHover(SidebarGuideInfoSectionTitle);

export default SidebarGuideInfoSectionTitleWithHover;



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarGuideInfoSection/SidebarGuideInfoSectionTitle.jsx